(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('PasswordCustom', PasswordCustom);

    PasswordCustom.$inject = ['$resource', 'ENV'];

    function PasswordCustom($resource, ENV) {

        var requestPasswordByPhoneNumber = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/account/reset_password_by_phone_number';
            return $resource(resourceUrl, {}, {}
            );
        };

        return {
            requestPasswordByPhoneNumber: requestPasswordByPhoneNumber
        }
    }
})();
